import { GETMEMBERTIMESHEET_SUCCESS, GETMEMBERTIMESHEET_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getMemberTimesheetReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETMEMBERTIMESHEET_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETMEMBERTIMESHEET_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getMemberTimesheetReducer;



